import React, { Fragment, useCallback, useEffect } from "react";
import { FORM_ELEMENTS_CLASSES } from "../../../../utils/form-builder.types";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
import { useFormData } from "../../../../hooks/client/use-form-data";
const FormBuilderFormInterfaceChoice = ({ item, analyticForm, t }) => {
  if (!item) return null;
  const { formData, hostElement } = useFormData();
  const elements = item.elements;
  const tags = FormBuilderElementsMappingService.getAllSingleElementHTMLTags(item);
  const legend = tags.legend[0];
  const input = tags.input[0];
  const isSingleChoice = item.class.includes(FORM_ELEMENTS_CLASSES.SINGLE_CHOICE);
  const onFocus = () => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(input.name);
  };
  const onBlur = () => analyticForm == null ? void 0 : analyticForm.trackInputBlurred(input.name);
  const onChange = useCallback(() => {
    var _a;
    const root = (_a = hostElement == null ? void 0 : hostElement.querySelector("div")) == null ? void 0 : _a.shadowRoot;
    const inputs = tags.input;
    const inputsArr = [];
    inputs.forEach((el) => {
      const inputHTML = root == null ? void 0 : root.getElementById(el.id);
      inputsArr.push(inputHTML);
    });
    const isAnyInputSelected = inputsArr == null ? void 0 : inputsArr.some((el) => (el == null ? void 0 : el.checked) === true);
    inputsArr == null ? void 0 : inputsArr.forEach((input2) => {
      input2 == null ? void 0 : input2.setCustomValidity(isAnyInputSelected ? "" : "Please tick any box if you want to proceed.");
    });
  }, [hostElement, tags.input]);
  useEffect(() => {
    if (!isSingleChoice && (input == null ? void 0 : input.required)) {
      onChange();
    }
  }, [input == null ? void 0 : input.id, input == null ? void 0 : input.required, isSingleChoice, onChange]);
  const currentOnChangeHandler = (() => {
    if (!isSingleChoice && (input == null ? void 0 : input.required)) {
      return onChange;
    }
    return () => {
    };
  })();
  return /* @__PURE__ */ React.createElement("fieldset", { className: item.class }, /* @__PURE__ */ React.createElement("legend", null, t(legend == null ? void 0 : legend.nodeValue)), elements.filter((el) => {
    var _a;
    return ((_a = el == null ? void 0 : el.nodeName) == null ? void 0 : _a.includes("input")) && (el == null ? void 0 : el.type) === "radio" || (el == null ? void 0 : el.type) === "checkbox";
  }).map((el, index) => {
    var _a, _b;
    const labelNodeValue = (_a = elements.find((label) => (label == null ? void 0 : label.for) === (el == null ? void 0 : el.id))) == null ? void 0 : _a.nodeValue;
    const defaultChecked = isSingleChoice ? (formData == null ? void 0 : formData[el.name]) === (el == null ? void 0 : el.value) : (_b = formData == null ? void 0 : formData[el.name]) == null ? void 0 : _b.find((value) => value === (el == null ? void 0 : el.value));
    return /* @__PURE__ */ React.createElement(Fragment, { key: index }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: input == null ? void 0 : input.type,
        name: el == null ? void 0 : el.name,
        id: el == null ? void 0 : el.id,
        defaultChecked,
        onFocus,
        onBlur,
        onChange: currentOnChangeHandler,
        value: el == null ? void 0 : el.value,
        required: isSingleChoice ? input == null ? void 0 : input.required : false
      }
    ), /* @__PURE__ */ React.createElement("label", { htmlFor: el == null ? void 0 : el.id }, t(labelNodeValue)));
  }));
};
FormBuilderFormInterfaceChoice.displayName = "FormBuilderFormInterfaceChoice";
export default React.memo(FormBuilderFormInterfaceChoice);
